import { useGetFileByTag } from "@/api/file.ts";
import { uploadDocument } from "@/api/image.ts";
import { useAuth } from "@/context/auth/AuthContext";
import { useTranslation } from "react-i18next";

import * as AF from "../form-items/AbstractForm";
import { Input } from "../ui/input";
import { FileText } from "lucide-react";
import { SupportedLocale } from "@/i18n";

interface ContactFormFormProps {
  language: SupportedLocale;
}

const ExpertiseForm = ({ language }: ContactFormFormProps) => {
  const { t } = useTranslation();
  const { instanceData } = useAuth();

  const tagDocument = "Expertise" + language.toLocaleUpperCase() + "_FORM";

  const { data: fileData, refetch } = useGetFileByTag(
    tagDocument,
    instanceData?.id ?? "",
  );

  const uploadDocumentFromInput = async (e: any) => {
    const file = e.target.files[0];

    if (!instanceData) {
      console.error("Tried to upload a document, but instanceData is null");
      return;
    }

    if (file) {
      await uploadDocument(file, instanceData.s3Bucket, {
        sourceName: "FormExpertise" + instanceData.name,
        title: file.name,
        tag: tagDocument,
        docId: instanceData.id,
        mimetype: "application/pdf",
        instanceId: instanceData.id
      });
      refetch();
    }
  };

  return (
    <AF.Col>
      <AF.Text
        name={`${language}.pageName`}
        label={t("cms.expertise.form.pageName")}
        tootltip={t("cms.expertise.form.pageName.tooltip")}
      />

      <AF.Text
        name={`${language}.title`}
        label={t("cms.expertise.form.title")}
        tootltip={t("cms.expertise.form.title.tooltip")}
      />

      <AF.RichText
        name={`${language}.content`}
        label={t("cms.expertise.form.content")}
      />
      <AF.Text
        name={`${language}.formDownloadCTA`}
        label={t("cms.expertise.form.formDownloadCTA")}
        tootltip={t("cms.expertise.form.formDownloadCTA.tooltip")}
      />

      <Input
        type="file"
        id="fichier"
        label={t("cms.expertise.form.document")}
        name="fichier"
        accept=".pdf"
        onChange={uploadDocumentFromInput}
      />

      {fileData && (
        <div className="flex items-center space-x-2 mt-2">
          <FileText className="w-4 h-4" />
          <a
            href={fileData.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {fileData.title}
          </a>
        </div>
      )}
    </AF.Col>
  );
};

export default ExpertiseForm;
